import script from "./RodapePrincipal.vue?vue&type=script&setup=true&lang=js"
export * from "./RodapePrincipal.vue?vue&type=script&setup=true&lang=js"

import "./RodapePrincipal.vue?vue&type=style&index=0&id=373712e9&scoped=true&lang=css"

import exportComponent from "/home/ewerson/Projetos/vue/vitrine_digital/vitrine-crescimentoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-373712e9"]])

export default __exports__